// libraries
import PropTypes from 'prop-types'
// component
import Button from '../../../atoms/button/button'
// icons
import { CloseIcon, SearchIcon } from '../../../atoms/icons'
import './search-input.scss'

const SearchInput = props => {
	const {
		value,
		showClose,
		handledValue,
		setShowClose,
		resetSearch,
		resetValue,
		placeholder = 'Busca lo que necesitas',
		cancelText = 'Cancelar',
		readOnly = false
	} = props

	return (
		<div className={`m-search-input ${showClose ? 'mt0' : 'mt2'}`}>
			<div className='m-search-input__input'>
				<input
					type='text'
					placeholder={placeholder}
					value={value}
					readOnly={readOnly}
					onChange={e => handledValue && handledValue(e.target.value)}
					onFocus={() => setShowClose && setShowClose(true)}
				/>

				<button className='m-search-input__input__button' onClick={() => showClose && resetValue()}>
					{showClose ? <CloseIcon color='#FC297F' /> : <SearchIcon color='#FC297F' />}
				</button>
			</div>
			<Button
				title={cancelText}
				classes={`flat ${showClose ? 'm-search-input__show' : 'm-search-input__hide'} `}
				onClick={() => resetSearch && resetSearch()}
			/>
		</div>
	)
}

SearchInput.propTypes = {
	value: PropTypes.string,
	showClose: PropTypes.bool,
	handledValue: PropTypes.func || PropTypes.bool,
	setShowClose: PropTypes.func || PropTypes.bool,
	resetSearch: PropTypes.func || PropTypes.bool,
	resetValue: PropTypes.func || PropTypes.bool,
	placeholder: PropTypes.string,
	cancelText: PropTypes.string,
	readOnly: PropTypes.bool
}

SearchInput.defaultProps = {
	placeholder: 'Busca lo que necesitas',
	cancelText: 'Cancelar',
	readOnly: false
}

export default SearchInput
